var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.phaseData)?_c('div',[_c('div',[_c('h1',{staticClass:"hypothesis-title"},[_vm._v("Hipótese diagnóstica: "+_vm._s(_vm.hypothesis().value))])]),_c('div',{staticClass:"mt-4"},[_c('p',{staticClass:"hypothesis-text"},[_vm._v(_vm._s(_vm.hypothesis().info))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }